import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "./auth.js";

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/Login" replace />;
  }
  return children;
};

export default ProtectedRoute;
